module.exports = __webpack_public_path__ + "static/media/icon-phone.292b8061.svg";